import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Clearfix, Row, Col, Button, Alert } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import AnimateHeight from 'react-animate-height';
import ScrollArea from 'react-scrollbar';
import { find as _find } from 'lodash';

import { getDescriptionInCurrentLanguage } from 'helpers/intl';
import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SepaAgreement from 'components/layout/sepa/SepaAgreement';

import PluginDetails from 'components/modals/PluginDetails';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';
import RichEditorContent from 'components/RichEditorContent';

import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class PluginActivateDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      detailsPlugin: null,
      sepaCheckboxChecked: false,
      termsOfUseCheckboxChecked: false,
      showTermsOfUse: false,
      contractCheckboxChecked: false,
      showContract: false,
      orderDataProcessingCheckboxChecked: false,
      showOrderDataProcessing: false,
    };
  }

  showDetails = detailsPlugin => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  getTermsOfUse = () => {
    const { appIntl, pluginActivationRequest } = this.props;
    const termsOfUseContent = _find(pluginActivationRequest.data.plugin.terms_of_use, [
      'language',
      appIntl.displayIntlForm,
    ]);
    return termsOfUseContent || {};
  };

  getContract = () => {
    const { appIntl, pluginActivationRequest } = this.props;
    const contractContent = _find(pluginActivationRequest.data.plugin.contract, ['language', appIntl.displayIntlForm]);
    return contractContent || {};
  };

  getOrderDataProcessing = () => {
    const { appIntl, pluginActivationRequest } = this.props;
    const orderDataProcessingContent = _find(pluginActivationRequest.data.plugin.order_data_processing, [
      'language',
      appIntl.displayIntlForm,
    ]);
    return orderDataProcessingContent || {};
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
      pluginActivationRequest,
    } = this.props;

    const crumbs = [
      { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
      { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
      { link: appIntl.urlPrefix + 'account/settings/plugins', name: messages.plugins },
    ];

    if (pluginActivationRequest.pending) {
      crumbs.push({ link: null, name: null });
    } else {
      crumbs.push({ link: null, name: messages.activate_plugin + ' • ' + pluginActivationRequest.data.plugin.name });
    }

    return <Breadcrumb crumbs={crumbs} className="p-t-0" />;
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      appIntl,
      history,
      formStatus,
      pluginActivationRequest,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      // if the plugin activation request is not active anymore, the plugin is now active
      if (formStatus.response.is_active) {
        doNotify(1, messages.plugin_partial_activated);
      } else {
        doNotify(1, messages.plugin_activated);
      }
      history.push(appIntl.urlPrefix + 'account/settings/plugins');
    }

    if (prevProps.pluginActivationRequest.pending && !pluginActivationRequest.pending) {
      // check if the plugin is already activated
      if (pluginActivationRequest.hasError) {
        history.push(appIntl.urlPrefix + 'account/settings/plugins');
      }
    }
  };

  onSubmit = () => {
    const { pluginActivationRequest, onSubmit } = this.props;
    onSubmit(pluginActivationRequest.data.white_label_project, pluginActivationRequest.data.id, {});
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      match,
      pluginActivationRequest,
      formStatus,
      myParent,
      user,
    } = this.props;
    const {
      sepaCheckboxChecked,
      termsOfUseCheckboxChecked,
      showTermsOfUse,
      contractCheckboxChecked,
      showContract,
      orderDataProcessingCheckboxChecked,
      showOrderDataProcessing,
    } = this.state;

    const isSoleRepresentative = may('ROLE_SOLE_REPRESENTATIVE', user.roles);
    const isPartRepresentative = may('ROLE_PART_REPRESENTATIVE', user.roles);

    const { pending } = formStatus;

    let submitDisabled = false;
    if (!pluginActivationRequest.pending) {
      if (!pluginActivationRequest.data.generate_sepa_agreement && !sepaCheckboxChecked) {
        submitDisabled = true;
      }

      if (pluginActivationRequest.data.plugin.terms_of_use_acceptation_needed && !termsOfUseCheckboxChecked) {
        submitDisabled = true;
      } else if (pluginActivationRequest.data.plugin.contract_acceptation_needed && !contractCheckboxChecked) {
        submitDisabled = true;
      } else if (
        pluginActivationRequest.data.plugin.order_data_processing_acceptation_needed &&
        !orderDataProcessingCheckboxChecked
      ) {
        submitDisabled = true;
      }
    }

    const sepaCheckbox = (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="sepaCheckbox"
            name="sepaCheckbox"
            type="checkbox"
            value="true"
            checked={sepaCheckboxChecked}
            onChange={e => this.setState({ sepaCheckboxChecked: e.target.checked })}
          />
          <label for="sepaCheckbox">{messages.sepaAgreement.i_issue_sepa_direct_debit_mandate}</label>
        </div>
      </div>
    );
    const termsOfUseCheckbox = (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="termsOfUseCheckbox"
            name="termsOfUseCheckbox"
            type="checkbox"
            value="true"
            checked={termsOfUseCheckboxChecked}
            onChange={e => this.setState({ termsOfUseCheckboxChecked: e.target.checked })}
          />
          <label for="termsOfUseCheckbox">
            {messages.i_read_and_accept_plugins_terms_of_use}

            {/* if the terms are not shown yet, show a view link */}
            {!showTermsOfUse ? (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showTermsOfUse: true })}>
                <i class="fas fa-eye" /> {messages.view}
              </a>
            ) : null}
          </label>
        </div>

        {/* container for the plugin's terms of use */}
        <AnimateHeight duration={500} height={showTermsOfUse ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className="b-a b-grey"
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={!pluginActivationRequest.pending ? this.getTermsOfUse() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );
    const contractCheckbox = (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="contractCheckbox"
            name="contractCheckbox"
            type="checkbox"
            value="true"
            checked={contractCheckboxChecked}
            onChange={e => this.setState({ contractCheckboxChecked: e.target.checked })}
          />
          <label for="contractCheckbox">
            {messages.i_read_and_accept_plugins_contract}

            {/* if the contract is not shown yet, show a view link */}
            {!showContract ? (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showContract: true })}>
                <i class="fas fa-eye" /> {messages.view}
              </a>
            ) : null}
          </label>
        </div>

        {/* container for the plugin's contract */}
        <AnimateHeight duration={500} height={showContract ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className="b-a b-grey"
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={!pluginActivationRequest.pending ? this.getContract() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );
    const orderDataProcessingCheckbox = (
      <div>
        <div class="checkbox check-success">
          <input
            disabled={pending}
            id="orderDataProcessingCheckbox"
            name="orderDataProcessingCheckbox"
            type="checkbox"
            value="true"
            checked={orderDataProcessingCheckboxChecked}
            onChange={e => this.setState({ orderDataProcessingCheckboxChecked: e.target.checked })}
          />
          <label for="orderDataProcessingCheckbox">
            {messages.i_read_and_accept_plugins_order_data_processing}

            {/* if the order data processing is not shown yet, show a view link */}
            {!showOrderDataProcessing ? (
              <a href="javascript:;" class="m-l-5" onClick={() => this.setState({ showOrderDataProcessing: true })}>
                <i class="fas fa-eye" /> {messages.view}
              </a>
            ) : null}
          </label>
        </div>

        {/* container for the plugin's order data processing */}
        <AnimateHeight duration={500} height={showOrderDataProcessing ? 'auto' : 0}>
          <ScrollArea
            speed={0.8}
            className="b-a b-grey"
            contentClassName=""
            horizontal={false}
            style={{ overflow: 'hidden', height: '300px' }}
          >
            <CmsPage
              data={!pluginActivationRequest.pending ? this.getOrderDataProcessing() : {}}
              doUpdateActiveCms={false}
              doUpdateDocMeta={false}
            />
          </ScrollArea>
        </AnimateHeight>
      </div>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.activate_plugin)}>
        <div class="padding-25 sm-padding-10">
          <Data dataName="myParent" url="/api/clients/parent.json" data={myParent} />
          <Data
            dataName="pluginActivationRequest"
            url={'/api/pluginactivationrequests/' + match.params.pluginActivationRequestId + '.json'}
            data={pluginActivationRequest}
          />

          {this.getBreadcrumb()}

          {pluginActivationRequest.pending || myParent.pending ? (
            <Loader />
          ) : (
            <div>
              <div class="panel b-rad-lg m-b-20">
                <div class="bg-master-lightest menuclipper padding-20 hidden-xs hidden-sm">
                  <Row>
                    <Col xs={4} md={3}>
                      <Clearfix>
                        <div class="pull-left font-secondary no-margin text-uppercase">
                          {pluginActivationRequest.data.plugin.name}
                        </div>
                      </Clearfix>
                    </Col>
                    <Col xs={8} md={5}>
                      <div class="font-secondary no-margin">
                        {messages.price_from}{' '}
                        {getDescriptionInCurrentLanguage(pluginActivationRequest.data.plugin.price_short_info, appIntl)}
                      </div>
                    </Col>
                    <Col xs={12} md={4}>
                      <Button block onClick={() => this.showDetails(pluginActivationRequest.data.plugin)}>
                        <i class="fas fa-info-circle" /> {messages.more_infos}
                      </Button>
                    </Col>
                  </Row>
                </div>
                <div class="panel-body">
                  <Row>
                    <Col xs={12}>
                      <RichEditorContent
                        content={
                          '<div>' +
                          getDescriptionInCurrentLanguage(pluginActivationRequest.data.plugin.description, appIntl) +
                          '</div>'
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>

              <div class="panel">
                <div class="panel-body">
                  {pluginActivationRequest.data.generate_sepa_agreement ? (
                    <div>
                      <SepaAgreement owner={pluginActivationRequest.data.plugin.owner} target={myParent.data} />
                    </div>
                  ) : null}

                  {/* show checkboxes for legal: */}
                  {pluginActivationRequest.data.generate_sepa_agreement ? sepaCheckbox : null}
                  {pluginActivationRequest.data.plugin.terms_of_use_acceptation_needed ? termsOfUseCheckbox : null}
                  {pluginActivationRequest.data.plugin.contract_acceptation_needed ? contractCheckbox : null}
                  {pluginActivationRequest.data.plugin.order_data_processing_acceptation_needed
                    ? orderDataProcessingCheckbox
                    : null}

                  <div>
                    {isPartRepresentative &&
                    (!pluginActivationRequest.data.activated_by ||
                      pluginActivationRequest.data.activated_by.length === 1) ? (
                      <Alert>{messages.not_sole_representative_click_below_to_request_plugin_activation}</Alert>
                    ) : null}

                    {isSoleRepresentative ||
                    (isPartRepresentative &&
                      pluginActivationRequest.data.activated_by &&
                      pluginActivationRequest.data.activated_by.length === 1) ? (
                      <Button block disabled={submitDisabled || pending} onClick={this.onSubmit}>
                        {pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                        {messages.activate_plugin}
                      </Button>
                    ) : (
                      <Button block disabled={submitDisabled || pending} onClick={this.onSubmit}>
                        {pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                        {messages.partially_activate_plugin}
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* show plugin details only if the data is already loaded */}
              <div id="plugin-details">
                <PluginDetails
                  plugin={pluginActivationRequest.data.plugin}
                  show={this.state.showDetails}
                  close={this.closeDetails}
                  mayActivate={false}
                />
              </div>
            </div>
          )}
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    myParent: state.data.myParent,
    pluginActivationRequest: state.data.pluginActivationRequest,
    formStatus: state.formStatus.pluginActivationRequest,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (whiteLabelId, pluginActivationRequestId, data) => {
      formStatusDispatchHelper(
        'pluginActivationRequest',
        '/api/whitelabels/' + whiteLabelId + '/pluginActivationRequest/' + pluginActivationRequestId + '/activate.json',
        data,
        'put',
        dispatch
      );
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PluginActivateDetails)
  )
);
